var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var GoogleMeetIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '24' : _b, _c = _a.height, height = _c === void 0 ? '16' : _c;
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "16", viewBox: "0 0 24 16", fill: "currentColor", className: "inline-block" }, { children: _jsx("path", { d: "M20 0C21.1 0 22 0.89 22 2V12C22 13.11 21.11 14 20 14H24V16H0V14H4C2.9 14 2 13.11 2 12V2C2 0.89 2.89 0 4 0H20ZM20 2H4V12H20V2ZM12 8C14.21 8 16 8.9 16 10V11H8V10C8 8.9 9.79 8 12 8ZM12 3C13.11 3 14 3.9 14 5C14 6.1 13.11 7 12 7C10.89 7 10 6.11 10 5C10 3.89 10.9 3 12 3Z" }) })));
};
export default GoogleMeetIcon;
